import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-grid-system";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebase_setup/firebase";
import { Card } from "flowbite-react";
import { ActivityDeleteBtn } from "./components/DeleteButton";
import ToastMSG from "./components/Toast";
import { ToastErrMSG } from "./components/Toast";
import HeaderBar from "./components/Header";

function DefaultCard(props) {
  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const isAdmin = currentUser?.Admin ? currentUser.Admin : false;
  let precio = props.price === 0 ? "Gratis" : props.price + "€";

  const onDelete = async (childData) => {
    // Cambiar Blocked a true en Firestore
    try {
      const activityRef = doc(db, "Activities", childData);
      await updateDoc(activityRef, { Blocked: true });
      props.changeDeleted(childData);
    } catch (error) {
      console.error("Error bloqueando actividad:", error);
      alert("No se pudo eliminar la actividad");
    }
  };

  return (
    <Card
      imgAlt="Imagen referente a la actividad"
      imgSrc={props.img}
      className="cardSize"
    >
      <div>
        <h5 className="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
          {props.name}
        </h5>
        <p className="font-normal text-gray-700 dark:text-gray-400 cardTextSize">
          {props.description}
        </p>
        <p className="font-normal text-gray-700 dark:text-gray-400 alignLeft">
          {precio}
        </p>
      </div>
      {isAdmin !== false ? (
        <ActivityDeleteBtn
          changeDeleted={onDelete}
          id={props.id}
          horariosActividades={props.horariosActividades}
        />
      ) : null}
    </Card>
  );
}

function MainPageComponent() {
  const [activities, setActivities] = useState([]);
  const [activitiesSchedules, setActivitySchedules] = useState([]);
  const [status, setStatus] = useState("");
  const [toastSuccess, setToastSuccess] = useState("");
  const [openMenu, setOpenMenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  const isAdmin = currentUser?.Admin ? currentUser.Admin : false;

  const changeDeleted = (childData) => {
    // Filtrar actividad eliminada localmente
    setActivities((prev) => prev.filter((a) => a.id !== childData));

    // Eliminar newActivity si coincide
    const newActivity = location.state?.newActivity;
    if (newActivity && newActivity.id === childData) {
      navigate(location.pathname, {
        state: { ...location.state, newActivity: null },
      });
    }

    setToastSuccess("Actividad eliminada correctamente");
    setStatus("success");
  };

  const toggleMenu = (menu) => setOpenMenu(openMenu === menu ? null : menu);

  useEffect(() => {
    if (location?.state?.message) {
      setToastSuccess(location.state.message);
      setStatus(location.state.err);
    }

    const fetchActivities = async () => {
      const q = query(
        collection(db, "Activities"),
        where("Blocked", "==", false)
      );
      const data = await getDocs(q);

      const actividades = data.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));
      setActivities(actividades);

      // Agregar newActivity solo si no está eliminada
      const newActivity = location?.state?.newActivity;
      if (newActivity && !actividades.some((a) => a.id === newActivity.id)) {
        setActivities((prev) => [...prev, newActivity]);
      }
    };

    const fetchActivitiesSchedules = async () => {
      const data = await getDocs(collection(db, "ActivitySchedule"));
      const horarioActividades = data.docs.map((item) => ({
        id: item.id,
        ...item.data(),
      }));
      setActivitySchedules(horarioActividades);
    };

    fetchActivities();
    fetchActivitiesSchedules();
  }, [location]);

  if (!activities[0] || !activitiesSchedules[0]) return null;

  const handleNavigate = (path, action, id = null) => {
    navigate(path, { state: { action, id } });
    setOpenMenu(null);
  };

  return (
    <>
      <Container data={activities}>
        <h1 className="marginTop titleActivities avatarTitle">Actividades</h1>

        {isAdmin && (
          <div className="flex gap-2">
            {/* Dropdown Gestionar Actividad */}
            <div className="relative">
              <button
                className="addBtn flex items-center gap-2 whitespace-nowrap"
                onClick={() => toggleMenu("actividad")}
              >
                <svg
                  className="w-5 h-5 text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 5.757v8.486M5.757 10h8.486M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <p className="whitespace-nowrap">Gestionar Actividad</p>
              </button>
              {openMenu === "actividad" && (
                <div className="absolute bg-white dark:bg-gray-800 shadow-md rounded mt-1 w-36 z-10">
                  <button
                    onClick={() => handleNavigate("/AddActivity", "nuevo")}
                    className="flex items-center gap-2 w-full px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    Nuevo
                  </button>
                  <button
                    onClick={() => handleNavigate("/AddActivity", "editar")}
                    className="flex items-center gap-2 w-full px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    Editar
                  </button>
                </div>
              )}
            </div>

            {/* Dropdown Gestionar Zona */}
            <div className="relative">
              <button
                className="addBtn flex items-center gap-2 whitespace-nowrap"
                onClick={() => toggleMenu("zona")}
              >
                <svg
                  className="w-5 h-5 text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 5.757v8.486M5.757 10h8.486M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <p className="whitespace-nowrap">Gestionar Zona</p>
              </button>
              {openMenu === "zona" && (
                <div className="absolute bg-white dark:bg-gray-800 shadow-md rounded mt-1 w-36 z-10">
                  <button
                    onClick={() => handleNavigate("/AddZone", "nuevo")}
                    className="flex items-center gap-2 w-full px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    Nuevo
                  </button>
                  <button
                    onClick={() => handleNavigate("/AddZone", "editar")}
                    className="flex items-center gap-2 w-full px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    Editar
                  </button>
                </div>
              )}
            </div>

            {/* Dropdown Gestionar Calendario */}
            <div className="relative">
              <button
                className="addBtn flex items-center gap-2 whitespace-nowrap"
                onClick={() => toggleMenu("calendario")}
              >
                <svg
                  className="w-5 h-5 text-gray-800 dark:text-white"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 20 20"
                >
                  <path
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M10 5.757v8.486M5.757 10h8.486M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                  />
                </svg>
                <p className="whitespace-nowrap">Gestionar Calendario</p>
              </button>
              {openMenu === "calendario" && (
                <div className="absolute bg-white dark:bg-gray-800 shadow-md rounded mt-1 w-36 z-10">
                  <button
                    onClick={() => handleNavigate("/AddCalendar", "nuevo")}
                    className="flex items-center gap-2 w-full px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    Nuevo
                  </button>
                  <button
                    onClick={() => handleNavigate("/AddCalendar", "editar")}
                    className="flex items-center gap-2 w-full px-3 py-1 text-sm hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    Editar
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        <Row>
          {activities.map((actividad) => (
            <Col
              sm={4}
              className="marginBot onClicNav"
              key={actividad.id}
              onClick={() =>
                navigate("/details", { state: { activity: actividad } })
              }
            >
              <DefaultCard
                name={actividad.Name}
                description={actividad.Description}
                price={actividad.Price}
                img={actividad.IMG}
                id={actividad.id}
                actividad={actividad}
                changeDeleted={changeDeleted}
                horariosActividades={activitiesSchedules}
              />
            </Col>
          ))}
        </Row>
      </Container>

      {status === "success" && (
        <nav onClick={() => setStatus("")}>
          <ToastMSG message={toastSuccess} />
        </nav>
      )}
      {status === "failure" && (
        <nav onClick={() => setStatus("")}>
          <ToastErrMSG message={toastSuccess} count={1} />
        </nav>
      )}
    </>
  );
}

export default function MainPage() {
  return sessionStorage.getItem("user") ? (
    <>
      <HeaderBar />
      <MainPageComponent />
    </>
  ) : (
    <Navigate replace to="/" />
  );
}
